import { createFileRoute } from '@tanstack/react-router';

function LoginPage(): React.JSX.Element {
  return (
    <main className="mx-auto flex max-w-3xl flex-col gap-4 px-6 py-16">
      <h1 className="font-display text-page-title font-semibold">
        Medintelekt login
      </h1>
      <p className="text-base text-muted-foreground">
        Authentication is handled by Keycloak. This route is reserved as a
        landing point for unauthenticated users; the AuthProvider redirects
        through Keycloak via the `omniwound-web` client.
      </p>
    </main>
  );
}

export const Route = createFileRoute('/login')({
  component: LoginPage,
});
